<template>
    <div class="cardTab">
        <div class="tabItem border" @click="tabItem(tab=1)">
            <div :class="{'active':tab==1}">
                <img class="income" src="@/assets/images/mealCard/income.png" alt="">
                <span>收入</span>
            </div>
        </div>
        <div class="tabItem" @click="tabItem(tab=2)">
            <div :class="{'active':tab==2}">
                <img class="expend" src="@/assets/images/mealCard/expend.png" alt="">
                <span>支出</span>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    data() {
        return {
            tab: 1,
        };
    },
    methods: {
        tabItem() {
            this.$emit("getTab", this.tab);
        }
    }
};
</script>
<style lang="scss" scoped>
@import "~@/scss/libs.scss";
.cardTab {
    font-size: 0;
    width: 100%;
    height: px2rem(88);
    border-bottom: px2rem(1) solid $shallowGray;
    border-top: px2rem(1) solid $shallowGray;
    background: white;
    @include dis-flex(center, space-between);
    .tabItem {
        width: 100%;
        line-height: px2rem(48);
        text-align: center;
        div {
            padding-top: px2rem(22);
            display: inline-block;
            height: px2rem(88);
        }
        .active {
            border-bottom: px2rem(6) solid #f7cd0f;
        }
        span {
            font-size: px2rem(28);
            color: $grayCyan;
            margin-left: px2rem(10);
        }
        img {
            vertical-align: top;
        }
        .income {
            width: px2rem(46);
            height: px2rem(42);
        }
        .expend {
            width: px2rem(41);
            height: px2rem(42);
        }
    }
    .border {
        border-right: px2rem(1) solid $shallowGray;
    }
}
</style>

